//追踪

import { userWebService }  from '@/utils/webService';
const webService = userWebService;
const discoverIvt = async()=>{
    const inviteCode = siteInit.cutParamCommand('ivt');
    if(inviteCode){
       await webService.uploadInviteEvent({inviteCode}).catch(err=>{
			console.error(err);
		});
    }
}


export default {discoverIvt};



// WEBPACK FOOTER //
// ./src/utils/trace.js